<template>
  <div class="ut-page-list elec-report-efficiency-analysis container-component">
    <div class="d2-container-full__body">
      <div class="ut-page-title-actions">
        <i class="el-icon-brush" style="font-size: 22px; color: #409eff"></i>
        <span title="损耗分析" class="page-title-text">配置</span>
        <el-button type="text" icon="el-icon-plus" @click="add">
          添加配置
        </el-button>
        <el-button type="text" icon="el-icon-position" @click="lossAnalysis">
          查看损耗分析
        </el-button>
        <el-button type="text" icon="el-icon-refresh" @click="update">刷新</el-button>
      </div>
      <div>
        <div class="d2-crud custom-crud">
          <div class="d2-crud-body">
            <div class="
                el-table
                table
                el-table--fit
                el-table--enable-row-hover
                el-table--enable-row-transition
                el-table--default
              ">
              <el-table :data="
                  list.slice(
                    (currentPage - 1) * pageSize,
                    currentPage * pageSize
                  )
                " style="width: 100%" :header-cell-style="{ fontSize: '18px' }">
                <el-table-column prop="name" label="名称" width="300">
                </el-table-column>
                <el-table-column prop="enterDevices" label="进线" width="500">
                  <template slot-scope="scope">
                    <span>永宁机电2数显表,永宁机电3数显表</span>
                  </template>
                </el-table-column>
                <el-table-column prop="outDevices" label="出线">
                  <template slot-scope="scope">
                    <span>永宁机电2数显表,永宁机电3数显表永宁机电4数显表</span>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="200" align="center">
                  <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button type="text" size="small" style="color: #f44336" @click="del(scope.row.id)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="d2-crud custom-crud">
          <div class="d2-crud-pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 30, 50]"
              layout="total, sizes, prev, pager, next, jumper" :total="list.length">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <configurationModule ref="myconfigurationModule" @append="append" :treeData="treeData"></configurationModule>
  </div>
</template>

<script>
  import configurationModule from "./configurationModule.vue";
  export default {
    components: {
      configurationModule,
    },
    data () {
      return {
        lossType: "全部", //损耗
        name: "", //名称
        currentPage: 1, //当前页
        pageSize: 10, //每页条数
        options: [{label: "全部"},{label: "线路损耗"}], //损耗类型数组
        list: [{
          name: 'B',
          enterDevices: [{aa: 1}],
          outDevices: [{aa: 1}],
        }], //数据集
        treeData: [],
      };
    },
    computed: {
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit;
      },
    },
    mounted () {
      this.getEnergyLossSetList();
      this.getReadClassTypeTree();
    },
    methods: {
      //刷新
      update () {
        this.$router.go(0);
      },
      //查看损耗分析
      lossAnalysis () {
        this.$router.push('./lossAnalysis')
      },
      //获取数据
      getEnergyLossSetList () {
        this.$api.deviceApi.getEnergyLossSetList(this.nowUnit.id,(res) => {
          this.list=res;
          // this.list.splice(0);
          // res.map((v) => {
          //   this.list.push(v);
          // });
        });
      },
      //获取树形数据
      getReadClassTypeTree () {
        this.$api.deviceApi.getReadClassTypeTree("",36,(res) => {
          let list=this.deviceList(res);
          this.treeData.push(list);
        });
      },
      //转换数据
      deviceList (list) {
        let elementList=JSON.parse(
          JSON.stringify(list).replace(/next/g,"children")
        );
        elementList=JSON.parse(
          JSON.stringify(elementList).replace(/name/g,"label")
        );
        return elementList;
      },
      //添加损耗配置
      add () {
        this.$nextTick(() => {
          this.$refs.myconfigurationModule.init("add");
        });
      },
      //编辑损耗配置
      handleClick (data) {
        console.log(data);
        this.$nextTick(() => {
          this.$refs.myconfigurationModule.init("edit",data);
        });
      },
      //删除
      del (id) {
        this.$confirm("确定要删除？","提示",{
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$api.deviceApi.deleteEnergyLossSet(id,(res) => {
              this.$message({
                type: "success",
                message: res,
              });
            });
            this.getEnergyLossSetList();
          })
          .catch(() => {});
      },
      //每页条数改变时触发 选择一页显示多少行
      handleSizeChange (val) {
        this.currentPage=1;
        this.pageSize=val;
      },
      //当前页改变时触发 跳转其他页
      handleCurrentChange (val) {
        this.currentPage=val;
      },
      //接收子组件数据
      append (data,type) {
        console.log(data);
        let enterDeviceNos=[];
        data.enterDevices.map((v) => {
          enterDeviceNos.push(v.no);
        });
        let outDeviceNos=[];
        data.outDevices.map((v) => {
          outDeviceNos.push(v.no);
        });
        console.log(data,type);
        if(type=="add") {
          this.$api.deviceApi.saveEnergyLossSetInfo(
            "",
            data.name,
            this.nowUnit.id,
            enterDeviceNos.join(","),
            outDeviceNos.join(","),
            (res) => {
              console.log(res);
              this.getEnergyLossSetList();
            }
          );
        } else {
          this.$api.deviceApi.saveEnergyLossSetInfo(
            data.id,
            data.name,
            this.nowUnit.id,
            enterDeviceNos.join(","),
            outDeviceNos.join(","),
            (res) => {
              console.log(res);
              this.getEnergyLossSetList();
            }
          );
        }
        this.$message({
          type: "success",
          message: "操作成功!",
        });
      },
    },
  };
</script>

<style scoped>
  .d2-container-full__body {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    height: 100%;
    padding: 20px;
    overflow: auto;
    position: relative;
  }

  .ut-page-title-actions {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 52px;
    padding: 0 15px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #f8f8f9;
  }

  .custom-crud {
    padding: 5px 15px 10px;
    background-color: #fff;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  .flex {
    display: flex;
  }

  /deep/.el-menu--horizontal>.el-menu-item {
    height: 40px;
    line-height: 40px;
  }

  .ut-page-title-actions .page-title-text {
    -webkit-box-flex: 1px;
    -ms-flex: 1px;
    flex: 1px;
    padding: 10px 7px;
    font-size: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .ut-page-title-actions .el-button {
    font-size: 14px;
    padding: 0 10px;
    position: relative;
    margin-left: 0;
  }

  .ut-page-list .el-form {
    background-color: #fff;
    padding: 35px 15px 0 25px;
  }

  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 18px;
  }

  .ut-page-list .table-search-form-single .form-adaption {
    margin-right: 25px;
  }

  /deep/.el-input--suffix .el-input__inner {
    height: 28px;
    line-height: 28px;
    border-radius: 25px;
  }

  .ut-page-list .table-search-form-single .form-adaption .search-form-select input {
    height: 28px;
    line-height: 28px;
    border-radius: 25px;
  }

  /deep/.el-input__icon {
    line-height: 28px;
  }

  .buttom .el-button--small {
    padding: 3px 20px;
    border-radius: 20px;
  }

  .line-list-row {
    width: 100%;
    padding-top: 10px;
    margin: 0;
    background-color: #fff;
  }

  .el-row:after,
  .el-row:before {
    display: table;
  }

  .ut-page-list .custom-card .el-card__body {
    padding: 10px;
  }

  .el-card {
    border: 1px solid #ebeef5;
    background-color: #fff;
    color: #303133;
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }

  .el-row--flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .card-head-title {
    font-size: 15px;
    color: #000;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    padding-right: 5px;
  }

  .card-head-no {
    color: #909399;
  }

  .card-body {
    padding: 10px 0;
  }

  .el-row--flex.is-justify-space-between {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  .card-body .grid-content>div {
    font-size: 13px;
    display: inline-block;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .card-body .grid-content .loss-info-value {
    padding: 7px 0;
  }

  .number {
    color: #303133;
    font-size: 24px;
    margin-right: 5px;
  }

  .el-col-0,
  .el-row--flex:after,
  .el-row--flex:before {
    display: none;
  }

  [class*="el-col-"] {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .card-body .grid-content {
    color: #909399;
    padding-left: 5px;
  }

  .card-bottom .btn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding-top: 8px;
  }

  .card-bottom .btn .el-button {
    color: #909399;
  }

  .ut-page-list .custom-crud {
    background-color: #fff;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  .ut-page-list .custom-crud .d2-crud-pagination {
    padding: 15px !important;
  }

  /deep/input:focus,
  textarea:focus {
    -webkit-box-shadow: none;
  }

  .el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: top;
  }

  .ut-page-list .table-search-form-single .form-adaption {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    margin-right: 15px;
  }

  /deep/.el-input--mini .el-input__inner {
    border-radius: 25px;
    width: 100% !important;
  }

  .ut-page-list .custom-crud .d2-crud-body,
  .ut-page-list .custom-crud .d2-crud-pagination {
    padding: 15px !important;
  }

  .el-table--fit {
    border-right: 0;
    border-bottom: 0;
  }

  .el-table {
    position: relative;
    overflow: hidden;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 100%;
    max-width: 100%;
    font-size: 14px;
    color: #606266;
  }

  .el-table,
  .el-table__expanded-cell {
    background-color: #fff;
  }

  .el-table:before {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
  }

  .el-table--border:after,
  .el-table--group:after,
  .el-table:before {
    content: "";
    position: absolute;
    background-color: #ebeef5;
    z-index: 1;
  }

  /* /deep/span {
  font-size: 12px;
} */
  .el-table .cell span {
    font-size: 12px;
  }

  /deep/.el-table th>.cell {
    font-size: 14px;
    color: #303133;
  }
</style>